.logo {
  display: block;
  flex: none;
  width: var(--space-5);
  height: var(--space-5);
}
